export enum BusinessType {
  CLIENT = 'Client Business',
  SELF = 'My Business'
}

export type BusinessTypeKey = keyof typeof BusinessType;

export const ClientBusinessTypeKey = 'CLIENT';
